<app-complex-modal-template
    titleSize="text-base"
    [canClose]="false"
    [canConfirm]="canConfirm()"
    [confirmLabel]="'validate'"
    [showBackButtonOnFirstStep]="true"
    [title]="'addComment' | transloco"
    (onClickEvent)="onClickEvent($event)">
    <textarea
        class="comment-textarea"
        [formControl]="commentControl"
        [maxLength]="data.maxLength"
        [placeholder]="'comment' | transloco: { COUNT: 1 }">
    </textarea>
</app-complex-modal-template>
